import { render } from "./BagItemLog.vue?vue&type=template&id=ccfda6cc"
import script from "./BagItemLog.vue?vue&type=script&lang=ts"
export * from "./BagItemLog.vue?vue&type=script&lang=ts"
script.render = render

export default script